module.exports = __webpack_public_path__ + "img/warning.51ed1c21.svg";